var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCordova(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.632 45.84H35.856L36.408 39.288H32.592L32.04 45.84H15.96L15.408 39.288H11.592L12.144 45.84H4.368L0 17.472L10.92 0H37.08L48 17.472L43.632 45.84ZM34.92 8.736H27.888L28.368 12H19.632L20.112 8.736H13.08L8.736 17.472L10.92 34.92H37.08L39.264 17.472L34.92 8.736ZM31.08 29.136C30.48 29.136 30 27.312 30 25.08C30 22.824 30.48 21 31.08 21C31.704 21 32.184 22.824 32.184 25.08C32.184 27.312 31.704 29.136 31.08 29.136ZM17.328 29.472C16.704 29.472 16.224 27.648 16.224 25.416C16.224 23.16 16.704 21.36 17.328 21.36C17.928 21.36 18.408 23.16 18.408 25.416C18.408 27.648 17.928 29.472 17.328 29.472Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCordova);
export default __webpack_public_path__ + "static/media/cordova.9ef8b009f840910c50bd401cbe59ce25.svg";
export { ForwardRef as ReactComponent };